var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxpopup"},[_c('div',{staticClass:"popup"},[_c('button',{on:{"click":function($event){return _vm.close()}}},[_vm._v("FECHAR")]),_c('br'),(
        _vm.imagem !== null &&
          _vm.imagem !== undefined &&
          _vm.imagem != 'none' &&
          _vm.imagem != ''
      )?_c('img',{staticClass:"photo",attrs:{"src":_vm.imagem}}):_c('img',{staticClass:"photo",attrs:{"src":_vm.imagemStatic}})])])}
var staticRenderFns = []

export { render, staticRenderFns }